import React from "react";
import { Block } from "jsxstyle";

const Loading = () => (
  <Block
    className="loading"
    position="absolute"
    top="0"
    right="0"
    bottom="0"
    left="0"
  />
);

export default Loading;



// WEBPACK FOOTER //
// ./modules/components/Loading.js